

































































import { Vue, Component, Ref, Prop } from "vue-property-decorator";
import { VForm } from "@/common/vuetify_types";
import { Employee } from "@/api";
import moment from "moment";
import { selfData } from "@/common/role_utils";
import {
  requiredString,
  noSpace,
  requiredSelectWithZero,
  maxFileSize,
} from "@/tool/validation";
import { dateFormat } from "@/common/date_format";

@Component
class MaintenanceRequestForm extends Vue {
  @Ref("form") form!: VForm;
  @Prop() readonly employees!: Employee[];

  get self() {
    return selfData();
  }
  details = "";
  location = "";
  assignee = 0;
  departmentId = 0;
  room = 0;
  bed = 0;
  deadline = "";
  formattedDeadline = "";
  departmentEmployees: Employee[] = [];
  minDate = moment()
    .local()
    .format("YYYY-MM-DD");
  deadlinePicker = false;
  creating = false;
  textRules = [requiredString, noSpace];
  selectRules = [requiredSelectWithZero];
  fileErr = "";
  counter = 0;
  document: File | null = null;
  documentName = "";
  url: string | ArrayBuffer | null | undefined = "";
  fileRules = [
    (v: File) => !v || maxFileSize(v, 5),
    // (v: File) => !!v || "File is required",
  ];

  close() {
    this.$store.dispatch("bed/clearBedState");
    this.$emit("close");
  }

  async submit() {
    if (!this.form.validate()) return;
    this.creating = true;
    const companyId =
      this.self?.companyId || this.$store.getters["getSelectedCompany"]?.id;
    const requestBody = {
      companyId,
      details: this.details,
      location: this.location,
    };

    await this.$store.dispatch("maintenanceRequest/addRequest", {
      payload: requestBody,
      file: this.document,
    });

    this.creating = false;
    this.close();
  }

  formatDate(date: string) {
    this.formattedDeadline = dateFormat(date);
  }

  onChangeFile(file: File) {
    this.fileErr = "";
    this.counter++;
    if (file) {
      const reader = new FileReader();

      reader.onload = (event: ProgressEvent<FileReader>) => {
        if (event) {
          this.documentName = file.name;
          this.url = URL.createObjectURL(file);
        }
      };
      reader.readAsArrayBuffer(file);
      this.document = file;
    }
  }
}
export default MaintenanceRequestForm;
